"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelContractsModule = void 0;
var fitpos_api_1 = require("../../../api/fitpos-api");
var date_helper_const_1 = require("@const/date-helper.const");
var error_helper_const_1 = require("@const/error-handling/error-helper.const");
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var object_service_1 = require("@services/object-service");
var translation_1 = __importDefault(require("@services/translation"));
var data_processing_service_1 = require("../services/data-processing.service");
var my_contracts_module_1 = require("./my-contracts.module");
var cash_dom_1 = __importDefault(require("cash-dom"));
var CancelContractsModule = /** @class */ (function () {
    function CancelContractsModule() {
        this.fitposAPI = object_service_1.ObjectService.getInstance(fitpos_api_1.FitposApi);
        this.dataProcessing = object_service_1.ObjectService.getInstance(data_processing_service_1.DataProcessing);
        this.myContractsModule = object_service_1.ObjectService.getInstance(my_contracts_module_1.MyContractsModule);
    }
    CancelContractsModule.prototype.loadModule = function (customer, moduleDiv) {
        return __awaiter(this, void 0, void 0, function () {
            var reasons, _ActionMapping;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('Customer', customer);
                        if (!customer) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fitposAPI.getCancellationReasons(customer.id)];
                    case 1:
                        reasons = _a.sent();
                        console.log('reasons', reasons);
                        (0, generator_const_1._CreateDropdown)('cancellation-reasons', 'text', reasons.map(function (a) { return (__assign(__assign({}, a), { text: a.cancelationReasonName })); }), function (entry) {
                            console.log('callback', entry);
                            _this.cancellationReasonId = entry.cancelationReasonId;
                        });
                        _ActionMapping = {
                            submit: function (event) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.submitCancelation(event, customer)];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); },
                        };
                        // confirm button
                        this.dataProcessing.mapDataAction(moduleDiv, _ActionMapping);
                        return [3 /*break*/, 2];
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    CancelContractsModule.prototype.submitCancelation = function (event, customer) {
        return __awaiter(this, void 0, void 0, function () {
            var contractId, selectedContract, container, e_1;
            var _a, _b, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        event.preventDefault();
                        event.stopPropagation();
                        if (((_b = (_a = this.myContractsModule) === null || _a === void 0 ? void 0 : _a.contracts) === null || _b === void 0 ? void 0 : _b.length) > 1) {
                            selectedContract = (_c = this.myContractsModule) === null || _c === void 0 ? void 0 : _c.selectedContract;
                            if (selectedContract === null || selectedContract === void 0 ? void 0 : selectedContract.id) {
                                contractId = selectedContract.id;
                            }
                            else {
                                alert('Bitte wähle den zu kündigenden Vertrag aus.');
                                return [2 /*return*/];
                            }
                        }
                        else if (((_e = (_d = this.myContractsModule) === null || _d === void 0 ? void 0 : _d.contracts) === null || _e === void 0 ? void 0 : _e.length) === 1) {
                            contractId = this.myContractsModule.contracts[0].id;
                        }
                        console.log('submitCANCELATION', event, this.cancellationReasonId, (_f = this.myContractsModule) === null || _f === void 0 ? void 0 : _f.selectedContract);
                        if (!(this.cancellationReasonId >= 0 && contractId)) return [3 /*break*/, 6];
                        console.log('reasons', this.cancellationReasonId);
                        _g.label = 1;
                    case 1:
                        _g.trys.push([1, 4, , 5]);
                        console.log('submit', contractId);
                        if (!contractId) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.fitposAPI.postContractCancelation(customer.id, {
                                contractId: contractId,
                                cancelationDate: (0, date_helper_const_1._GetUserLocalTime)()
                                    .toISOString()
                                    .replace(/T.*/, ''), //TODO change
                                cancelationReasonId: 1, //TODO change
                            })];
                    case 2:
                        _g.sent();
                        _g.label = 3;
                    case 3:
                        container = (0, cash_dom_1.default)('[data-module="cancel-contract"] [data-redirect]');
                        if (container === null || container === void 0 ? void 0 : container.length) {
                            console.log('REDIRECT', container);
                            window.location.href = container.attr('data-redirect');
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _g.sent();
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        (0, error_helper_const_1._AddErrorToDomObject)((0, cash_dom_1.default)('#cancellation-reasons-container'), translation_1.default.t('Cancellation reason is required'));
                        _g.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    return CancelContractsModule;
}());
exports.CancelContractsModule = CancelContractsModule;
